<template>
	<div class="space-y-sm">
		<p class="flex items-center space-x-xs font-bold">
			<v-icon :icon="icon" class="text-xl text-red-500"> </v-icon>

			<span>
				{{ title }}
			</span>
		</p>

		<div
			class="mb-lg divide-y divide-gray-100 rounded-2xs border border-gray-100"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type {Icon} from "@pkg/shared/types";

defineProps<{
	icon: Icon;
	title: string;
}>();
</script>
